import { render, staticRenderFns } from "./pourquoi_section.vue?vue&type=template&id=139b9590&scoped=true"
import script from "./pourquoi_section.vue?vue&type=script&lang=js"
export * from "./pourquoi_section.vue?vue&type=script&lang=js"
import style0 from "./pourquoi_section.vue?vue&type=style&index=0&id=139b9590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b9590",
  null
  
)

export default component.exports